/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentProcessingReceiptIntelligenceStatus =
    (typeof DocumentProcessingReceiptIntelligenceStatus)[keyof typeof DocumentProcessingReceiptIntelligenceStatus];

export const DocumentProcessingReceiptIntelligenceStatus = {
    Enriched: 'Enriched',
    Failed: 'Failed',
    Skipped: 'Skipped',
    NotRun: 'NotRun',
    Pending: 'Pending',
} as const;
